// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"532":"845cf323551727f686e0","589":"6c2cc9590f970474d88c","678":"cb12012b2fb4de798cfd","883":"812b94f0c8085a16e5dd"}[chunkId] + ".js";
};